import { getProjectionData } from "@/services/ct.service.js"
import { getConfig } from "@/constants/config"

export const getProjectionPartListData = async partList => {
  try {
    const response = await getConfig()
    const currencyCode = response?.internationalization?.currencyCode
    const currencySign = response?.internationalization?.currencySign
    const itemsCount = 20
    let startFrom = 0
    let endTo = itemsCount
    const initialList = []
    const groupArrayCount = Math.ceil(partList.length / itemsCount)
    const skus = partList.map(val => val.skuId)
    if (partList?.length <= itemsCount) {
      const resp = await getProjectionData({ skus })
      const { repParts, replacementPartlist } = await getReplacementItem(resp)
      const prices = getPartsPricebySku(
        replacementPartlist,
        currencyCode,
        currencySign
      )
      const { replacementPartsInfo, replacementParts } = replacementProductInfo(
        replacementPartlist,
        prices,
        repParts
      )
      return {
        replacementParts,
        replacementPartsInfo,
        pricing: getPartsPricebySku(
          [...resp, ...replacementPartlist],
          currencyCode,
          currencySign
        ),
      }
    } else {
      const list = []
      Array.from({ length: groupArrayCount }, () => {
        list.push([partList.slice(startFrom, endTo)])
        startFrom = endTo
        endTo = endTo + itemsCount
        return null
      })
      list.forEach(val => {
        const skus = val[0].map(v => v.skuId)
        const resp = getProjectionData({ skus })
        initialList.push(resp)
      })
      const res = await Promise.allSettled(initialList)
      const combineItem = res.flatMap(x => x.value)
      const { repParts, replacementPartlist } = await getReplacementItem(
        combineItem
      )
      const prices = getPartsPricebySku(
        replacementPartlist,
        currencyCode,
        currencySign
      )
      const { replacementPartsInfo, replacementParts } = replacementProductInfo(
        replacementPartlist,
        prices,
        repParts
      )
      return {
        replacementParts,
        replacementPartsInfo,
        pricing: getPartsPricebySku(
          [...combineItem, ...replacementPartlist],
          currencyCode,
          currencySign
        ),
      }
    }
  } catch (err) {
    return err
  }
}
const getPartsPricebySku = (list, currencyCode = "USD", currencySign = "$") => {
  const sortItems = i => ({
    sku: i?.sku,
    currencySign,
    discountPrices: i?.prices
      .filter(i => {
        return i?.discounted?.value?.currencyCode === currencyCode
      })
      .reduce((a, i) => {
        return {
          ...a,
          [i?.customerGroup?.obj?.key ?? "ANY"]: i?.discounted?.value,
        }
      }, {}),
    prices: i?.prices
      .filter(i => {
        return i?.value?.currencyCode === currencyCode
      })
      .reduce((a, i) => {
        return { ...a, [i?.customerGroup?.obj?.key ?? "ANY"]: i?.value }
      }, {}),
  })
  return list.reduce((acc, sku) => {
    return {
      ...acc,
      [sku?.masterVariant?.sku]: [
        ...sku.variants.map(sortItems),
        ...[sku.masterVariant].map(sortItems),
      ],
    }
  }, {})
}

const getReplacementItem = async projection => {
  const rootSku = []
  const repParts = projection
    .map(i => {
      const values = i.variants.reduce((acc, j) => {
        const x = j.attributes.filter(i => i.name === "SKUSupersededBy")
        if (x?.[0]?.value !== undefined && x?.[0]?.value !== "DISC.")
          return { ...acc, [j?.sku]: x?.[0]?.value }
        return acc
      }, {})

      const masterValue = i.masterVariant.attributes.filter(
        i => i.name === "SKUSupersededBy"
      )?.[0]?.value

      const ProductProductNo = i.masterVariant.attributes.filter(
        i => i.name === "ProductProductNo"
      )?.[0]?.value

      if (masterValue !== undefined && masterValue !== "DISC.")
        values[i.masterVariant.sku] = masterValue

      return {
        value: values,
        key: { ProductProductNo, sku: i.masterVariant.sku },
      }
    })
    .filter(i => {
      const value = Object.values(i?.value)
      const key = Object.keys(i.value)[0]
      const val = value.includes(i?.key?.sku) || value.includes(key)
      const key1 = key?.split("-")[0]
      const val1 = value[0]?.split("-")[0]
      if (value.length !== 0 && !val && key1 !== val1) {
        return true
      }
    })
    .reduce((res, item) => {
      rootSku.push(Object.values(item.value))
      item.value.ProductProductNo = item?.key?.ProductProductNo
      return {
        ...res,
        [item?.key?.ProductProductNo]: item.value,
      }
    }, {})
  const convertArrayItem = rootSku.flat()
  const resp =
    rootSku.length !== 0
      ? await getProjectionData({ skus: convertArrayItem })
      : []
  return {
    repParts,
    replacementPartlist: resp,
  }
}

const priceUpdate = (currentPrice, type) => {
  return (currentPrice?.prices[type]?.centAmount / 100)?.toFixed(2) ?? null
}

const replacementProductInfo = (partsItems, priceList, replacementProducts) => {
  const updatePartList = partsItems.map(values => {
    const { masterVariant, slug, name } = values
    const skuNo = masterVariant["sku"]
    const ProductNo = masterVariant?.attributes.filter(
      v => v?.name === "ProductProductNo"
    )[0]?.value
    const currentPrice = priceList[skuNo]?.filter(v => v?.sku === skuNo)[0]
    return {
      Cod: ProductNo,
      Name: name["en-US"],
      ctrPrice: priceUpdate(currentPrice, "CTR"),
      ffPrice: priceUpdate(currentPrice, "FF"),
      guestPrice: priceUpdate(currentPrice, "GST"),
      kemprPrice: priceUpdate(currentPrice, "KEMP"),
      productId: ProductNo,
      skuId: skuNo,
      slug: slug["en-US"],
      stockStatus: true,
      tprPrice: priceUpdate(currentPrice, "TPR"),
      tvsPrice: priceUpdate(currentPrice, "TVS"),
      productDetails: values,
    }
  })
  const replaceValue = Object.values(replacementProducts)
  const replacementParts = replaceValue.reduce((res, item) => {
    const ProductProductNo = item.ProductProductNo
    delete item.ProductProductNo
    const currentVal = updatePartList.filter(
      v => v?.Cod?.split("-")[0] === Object.values(item)[0]?.split("-")[0]
    )
    if (currentVal.length !== 0) {
      item.ReplaceProductProductNo = currentVal[0]?.Cod
    }
    return {
      ...res,
      [ProductProductNo]: item,
    }
  }, {})
  return { replacementPartsInfo: updatePartList, replacementParts }
}
